import { amplitude } from "@eis-poc/lib-discover-medical-mfes";

const AMPLITUDE_API = "api.amplitude.com";

export const instantiateAmplitude = ({ amplitudeInfo, userData, optOut }) => {
  const { amplitudeApiKey, analyticsApi } = amplitudeInfo;

  const apiEndpoint =
    analyticsApi === AMPLITUDE_API ? analyticsApi : `${analyticsApi}`;

  if (!amplitudeApiKey) {
    return;
  }

  // Instantiate Amplitude
  const opts = {
    includeReferrer: true,
    unsetParamsReferrerOnNewSession: true,
    saveParamsReferrerOncePerSession: false,
    includeUtm: true,
    optOut,
    ...(analyticsApi && {
      apiEndpoint
    })
  };

  amplitude.initAnalytics(amplitudeApiKey, opts);
  if (userData) {
    updateAmplitudeUser(userData);
  }
};

export const updateAmplitudeUser = ({
  customerInfo,
  puaId,
  trafficSource,
  interfaceId
}) => {
  const { customerId, groupId, profileId } = customerInfo || {};

  const { authMethodPrimary, authMethodSecondary, ehrVendor, ehrLocation } =
    trafficSource || {};

  amplitude.setUser(puaId || null);
  amplitude.setUserInfo({
    cust_id: customerId,
    customer_ID: customerId,
    interface_id: interfaceId,
    group_id: groupId,
    profile_id: profileId,
    auth_method_primary: authMethodPrimary,
    auth_method_secondary: authMethodSecondary,
    ehr_vendor: ehrVendor,
    ehr_location: ehrLocation,
    screen_w: `${window.screen.width}`,
    screen_h: `${window.screen.height}`,
    viewport_w: `${window.innerWidth}`,
    viewport_h: `${window.innerHeight}`
  });
};

/**
 * Handles appending amplitude device ID query param to a given url
 *
 * @param {string} url
 */
export const appendAmplitudeDeviceId = (url) => {
  const deviceId = amplitude.getUserDevice();
  if (typeof window !== "undefined" && url && deviceId) {
    const separator = url.indexOf("?") === -1 ? "?" : "&";
    return `${url}${separator}amp_device_id=${deviceId}`;
  } else {
    return url;
  }
};
